import setGlobalState from '../../../redux/setGlobalState';
import store from '../../../store';
import {mobileScreen} from '../../../globalVariables/GlobalVariables';

/** The one way the panel is closed from code — the header's own close adds what only it knows. */
export function closeAgentPanel(): void {
    setGlobalState('aiAgent.isOpen', false);
}

/** The same cut useMobile makes, for code that runs outside a render. */
export function isMobileViewport(): boolean {
    return store.getState().ui.windowWidth < mobileScreen;
}
